import PrivateRoute from "./privateRoute";
import LOOKUP from "./constants/lookup";

// IMPORTS

import POSPage from './screens/containers/sales/pos/POSPage';

import ProductListPage from "./screens/containers/inventory/product/ProductList";
import ProductCategoryPage from './screens/containers/inventory/productCategory/ProductCategoryPage';
import PurchaseOrderPage from './screens/containers/inventory/purchaseOrder/PurchaseOrderPage';
import TransferPage from './screens/containers/inventory/transferProduct/TransferPage';
import BulkTransfer from './screens/containers/inventory/bulkTransfer/bulkTransfer';
import InventoryAdjust from './screens/containers/inventory/inventoryAdjust/InventoryAdjust';
import InventoryAuditList from './screens/containers/inventory/audit/AuditList';
import MultiStoreManagement from './screens/containers/inventory/multiStoreManagement/multiStoreManagement';

import VendorPage from "./screens/containers/inventory/vendor/VendorPage";
import VendorCatalog from './screens/containers/inventory/vendor/VendorCatalog';

import PatientListPage from "./screens/containers/user/patient/PatientList";
import EmployeeList from "./screens/containers/user/employee/EmployeeList";
import DoctorPage from "./screens/containers/user/doctor/DoctorPage";
import UserRoleList from "./screens/containers/user/role/UserRoleList";

import BankDepositPage from './screens/containers/admin/bankDeposits/BankDepositPage';
import CashRegisterPage from './screens/containers/admin/cashRegister/CashRegisterPage';
import ShiftListPage from './screens/containers/admin/shifts/ShiftList';
import SchedulePage from './screens/containers/admin/schedule/schedulePage';
import OrderListPage from './screens/containers/admin/order/OrderList';
import CommunicatingPage from './screens/containers/admin/communicating/communicatingPage';
import SettingPage from './screens/containers/admin/setting/SettingPage';

import ReportPage from './screens/containers/report/ReportPage';

import MeasurementPage from './screens/containers/manage/measurement/MeasurementPage';
import PriceMatrixPage from './screens/containers/inventory/priceMatrix/PriceMatrixPage';

import TaxRatePage from './screens/containers/manage/taxrate/TaxRatePage';
import CampaignPage from './screens/containers/manage/campaign/CampaignPage';
import ComboPage from './screens/containers/manage/combo/ComboPage';
import DiscountPage from './screens/containers/manage/discount/DiscountPage';

import DevicePage from './screens/containers/manage/device/DevicePage';
import PaymentPage from './screens/containers/manage/payment/PaymentPage';
import PriceUpdatePage from './screens/containers/manage/priceupdate/PriceUpdateList';
import StoreList from './screens/containers/home/StoreList';

import OnlineOrdersPage from './screens/containers/ecommerce/onlineOrders/OnlineOrdersPage';
import StoreRulesPage from './screens/containers/ecommerce/storerules/storeRulesPage';
import ProductGroupPage from './screens/containers/ecommerce/productGroupPage';
import CarouselPage from './screens/containers/ecommerce/carousel/carouselPage';
import HomeSettingPage from './screens/containers/ecommerce/homesetting/homesettingPage';
import UISettingPage from './screens/containers/ecommerce/uisetting/UISettingPage';
import SEOSettingPage from './screens/containers/ecommerce/seosettings';
import BannerListPage from './screens/containers/ecommerce/bannerList/bannerListPage';


import VideoSupportPage from './screens/containers/support/video-support/VideoSupportPage';
import NewFeatures from './screens/containers/support/topics/New Features/NewFeatures';
import IntegrationOverview from "./screens/containers/integration/integrationOverview";

import SafeManagementPage from './screens/containers/admin/safemanagement/SafeManagementPage';
import UserRoleSave from "screens/containers/user/role/UserRoleSave";
import SafeManageMentList from "./screens/containers/admin/safemanagement/SafeManageMentList";

// this map object is needed so that the components can be referenced by the component name from LOOKUP object 'componentMap[componentName]' and passed to the PrivateRoute function

const componentMap = {
    POSPage,
    ProductListPage,
    ProductCategoryPage,
    PurchaseOrderPage,
    TransferPage,
    BulkTransfer,
    InventoryAdjust,
    InventoryAuditList,
    MultiStoreManagement,
    VendorPage,
    VendorCatalog,
    PatientListPage,
    EmployeeList,
    DoctorPage,
    SafeManagementPage,
    UserRoleList,
    BankDepositPage,
    CashRegisterPage,
    ShiftListPage,
    SafeManageMentList,
    SchedulePage,
    OrderListPage,
    CommunicatingPage,
    SettingPage,
    ReportPage,
    MeasurementPage,
    PriceMatrixPage,
    TaxRatePage,
    CampaignPage,
    ComboPage,
    DiscountPage,
    DevicePage,
    PaymentPage,
    PriceUpdatePage,
    OnlineOrdersPage,
    StoreRulesPage,
    ProductGroupPage,
    CarouselPage,
    HomeSettingPage,
    UISettingPage,
    VideoSupportPage,
    NewFeatures,
    IntegrationOverview,
    StoreList,
    UserRoleSave,
    SEOSettingPage,
    BannerListPage
};

const createPrivateComponent = (componentName, pageId) => {
    const originalComponent = componentMap[componentName];

    if (originalComponent) {
        const privateComponentName = `Private${componentName}`;
        const privateComponent = PrivateRoute(originalComponent, pageId);
        Object.defineProperty(privateComponent, 'name', { value: privateComponentName });

        return privateComponent;
    } else {
        console.error(`Component '${componentName}' not found.`);
        return null;
    }
}

const generatePrivateComponents = (menuItems) => {
    const privateComponents = {};

    const createComponent = (item) => {
        if (item.component && item.pageId) {
            const privateComponent = createPrivateComponent(item.component, item.pageId);
            if (privateComponent) {
                privateComponents[item.component] = privateComponent;
            }
        }
    }

    for (const menuItem of menuItems) {
        createComponent(menuItem);

        if (menuItem.items) {
            for (const subMenuItem of menuItem.items) {
                createComponent(subMenuItem);
            }
        }
    }

    return privateComponents;
};

// EXPORT PRIVATE COMPONENTS

export const privateComponents = generatePrivateComponents(LOOKUP.menuData);
